
import axios from 'axios';
import { API_URL } from './constants';

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('refreshToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    } else {
      console.error('No access token found');
    }
    console.log('Request config:', config); // Log request configuration
    return config;
  },
  (error) => {
    console.error('Request error:', error); // Log request error
    return Promise.reject(error);
  }
);

export default api;
